import AddUser from "./AddUser";
import { AddUserPayload, AddUserProps } from "./AddUser";
export default AddUser;
export type { AddUserPayload, AddUserProps }